import styled from '@emotion/styled';
import FixedWidth from 'components/FixedWidth';
import customers from './customers.png';

const StyledSection = styled.section`
  padding: 2.5rem 0 6rem 0;
  background-color: #f8f7f7;
  h2 {
    color: #6f6259;
  }
  text-align: center;
  & img {
    max-width: 794px;
    @media (max-width: 756px) {
      width: 100%;
    }
  }
`;

const Center = styled.div``;

export default function Customers(): JSX.Element {
  return (
    <StyledSection>
      <FixedWidth>
        <p>
          Join these forward-thinking companies in building strong, happy,
          highly productive teams. <br />
          Partner with Inkwell for your talent acquisition needs today.
        </p>
        <h2>Trusted by</h2>
        <img src={customers} alt="Customers" />
      </FixedWidth>
    </StyledSection>
  );
}
